import { usePaymentCreatePaymentAccount } from "@crowdcoursing/api/openapi";
import { useCallback, useEffect } from "react";

import { useSelector } from "~hooks/useTypedRedux";
import { valueOrFallback } from "~utils/sanitizeDto";

import { type State } from "../../../state/state";

/**
 * Implements the stripe profile creation refresh_url redirect.
 * {@link https://stripe.com/docs/api/account_links/create#create_account_link-refresh_url}
 */
export function ProfileRefresh() {
  const userId = useSelector((state: State) =>
    valueOrFallback(state.user?.id, "NO_USER_ID", "(ProfileRefresh) state.user.id is undefined"),
  );
  const { mutateAsync } = usePaymentCreatePaymentAccount({
    onSettled(data) {
      if (!data?.url) {
        console.error("(ProfileRefresh) Missing url");
      }
      if (data?.url) {
        window.location.assign(data.url);
      }
    },
  });

  const redirectToStripeProfileCreation = useCallback(
    async function (id: string) {
      return mutateAsync({ pathParams: { userId: id } });
    },
    [mutateAsync],
  );

  useEffect(() => {
    void redirectToStripeProfileCreation(userId);
  }, [redirectToStripeProfileCreation, userId]);

  return null;
}
